module.exports = __webpack_public_path__ + "img/CARACTER-SWIFT-1.7184a021.jpg";